import { PlayerJumpShipTimingType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const playerJumpShipTimingName: { [key in PlayerJumpShipTimingType]: TKeyType } = {
  [PlayerJumpShipTimingType.NOW]: 'playerJumpShipTiming.now',
  [PlayerJumpShipTimingType.END_OF_MONTH]: 'playerJumpShipTiming.endOfMonth'
}

export default playerJumpShipTimingName
